<template>
  <li class="nav-lang">
    <span @click.prevent="toggle" class="current-lang">{{ $i18n.locale.toUpperCase() }}</span>
    <ul class="sub-menu" v-show="expanded">
      <li v-for="(name, key) in langs" :key="key" class="lang" @click="setLang(key)"
        :class="{ active: $i18n.locale === key }">
        {{ key.toUpperCase() }}
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: "NavLang",
  props: ["seasons"],
  data() {
    return {
      expanded: false,
      langs: {
        "en": "English",
        "fr": "Français",
      },
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.expanded = false;
        window.removeEventListener("click", this.close);
      }
    },
    setLang(lang){
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.expanded = false;
    },
  },
  watch: {
    $route() {
      this.expanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/main.scss";
.nav-lang {
  user-select: none;
  position: relative;
  .current-lang {
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .sub-menu {
    background: #222;
    color: white;
    position: absolute;
    right: 0;
    top: $navbar-height;
    line-height: normal;
    border-radius: 5px;
    padding: 5px 0;
    min-width: 60px;
  }
}
.lang {
  list-style-type: none;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  text-align: center;
  &:hover {
    background: #333;
  }
  &.active {
    color: $primary;
  }
}
@media only screen and (max-width: $mobile-breakpoint) {
  .nav-lang {
    .sub-menu {
      position: static;
      transform: none;
      margin-bottom: 15px;
      display: flex;
      gap: 10px;
      background: transparent;
    }
  }
}

@media only screen and (min-width: $mobile-breakpoint) {
  .nav-lang {
    .sub-menu::after {
      content: "";
      position: absolute;
      top: 0;
      right: 17px;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-bottom-color: #222;
      border-top: 0;
      margin-left: -10px;
      margin-top: -10px;
    }
  }
}
</style>
